import type { Message } from '.';

const buildDetailInfoLink = (message: Message) => {
  const { content, link } = message;
  if (link) {
    return (
      <p>
        {`${content} `}
        <a href={link} target="_blank" rel="noreferrer">
          {' '}
          - See Details
        </a>
      </p>
    );
  } else {
    return <p>{content}</p>;
  }
};

export default buildDetailInfoLink;
